import axios from "axios";

// CRA injects envs at build time under process.env.REACT_APP_*
const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL || // optional alias
  "";

// Fail fast in prod if missing to avoid silent relative calls
if (!baseURL && process.env.NODE_ENV === "production") {
  throw new Error(
    "API base URL missing. Set REACT_APP_API_BASE_URL in Vercel env and redeploy."
  );
}

const api = axios.create({
  baseURL, // e.g. https://your-api.onrender.com/api
  withCredentials: true, // keep if you use cookies
  headers: { Accept: "application/json" },
});

// Debug: confirm in browser console
// if (typeof window !== "undefined") {
//   console.log("[api] baseURL =", api.defaults.baseURL);
// }

export default api;
